import 'reflect-metadata';
import { createApp } from 'vue';
import '@ui/styles.css';
import { toast, ToastError } from '@ui/components/sonner';
import { HttpError } from '@stuut/common/src/api_client';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import plugins from './plugins';
import router from './router';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function stuutErrorHandler(err, instance, info) {
  if (err instanceof ToastError) {
    toast.error(err.message);
    return true;
  } else if (err instanceof HttpError && err.clientMessage) {
    toast.error(err.clientMessage);
    return true;
  }
  return false;
}

function isBotErrorSpam(event) {
  const msg = String(
    event.message || event.exception?.values?.[0]?.value || '',
  );

  // Ignore this signature
  if (
    /Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+/.test(
      msg,
    )
  ) {
    return true;
  }

  if (
    /\[PostHog\.js\]\s+This capture call is ignored due to client rate limiting\./i.test(
      msg,
    )
  ) {
    return true;
  }

  return false;
}

const app = createApp(App);
if (process.env.STUUT_SENTRY_DSN) {
  Sentry.init({
    app,
    environment: process.env.NODE_ENV || 'development',
    dsn: process.env.STUUT_SENTRY_DSN,
    integrations: [Sentry.captureConsoleIntegration({ levels: ['error'] })],
    beforeSend(event, hint) {
      const isHandled = stuutErrorHandler(hint.originalException, null, null);
      if (isHandled || isBotErrorSpam(event)) {
        return null;
      }
      return event;
    },
  });
}

app.use(plugins);
app.use(router);

app.directive('visible', (el, binding) => {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});

app.mount('#app');
